<template>
    <v-dialog v-model="visible" max-width="350" persistent>
        <v-card style="border-radius: 14px;" class="justify-space-between">
            <v-card-title class="d-flex align-center justify-space-between text-h6 white--text" >
                <div class="d-flex align-center ">
                    <v-icon class="mr-4">mdi-file-sign</v-icon>
                    <span>{{ pregunta }}</span>
                </div>
                <v-icon @click="selection('cerrar')" style="cursor: pointer;">mdi-close</v-icon>
            </v-card-title>
    
            <v-card-actions class="justify-center">
                <v-btn style="background-color: #FF5252;" @click="selection('no')" text="NO" />
                <v-btn style="background-color: #4CAF50;" @click="selection('si')" text="SI" />
            </v-card-actions>
        </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: "PreguntaDialog",
    data() {
      return {
        visible: false,
        pregunta: '',
        callbackSi: null,
      };
    },
    methods: {
      abrir(pregunta, callbackSi) {
        this.pregunta = pregunta;
        this.callbackSi = callbackSi;
        this.visible = true;
      },
      selection(param) {
        if (this.callbackSi) this.callbackSi(param);
        this.visible = false;
      },
    },
  };
  </script>
  <style scoped>
    .v-card {
        border-radius: 102px;
    }
    /* Personaliza estilos si es necesario */
  </style>